import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.assign.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import Logger from 'js-logger';
import { make } from 'vuex-pathify';
import Vue from 'vue';
import QuestionTypes, { insertFollowUpQuestions, getSortedQuestions, getTriggeredFollowUpQuestions } from '@/store/helpers/questionTypes';

var defaultState = function defaultState() {
  return {
    sections: {},
    completedScreens: []
  };
};

var state = defaultState();

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions

  /**
   * Render a survey question to a screen.
   */
  renderSurveyQuestion: function renderSurveyQuestion(_ref, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getters;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getters = _ref.getters;
              _context.next = 3;
              return QuestionTypes.render({
                section: getters.getSection('questions'),
                survey: getters.getSurvey,
                question: payload.surveyQuestion
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Builds screens for the question section. Please ensure that this is only called when all dependent
   * sections have been passed.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Function} commit Vuex module commit
   * @param {Object} rootState Vuex root state
   * @param {Object} rootGetters Vuex root getters
   *
   * @returns {Array} Array of questions
   */
  buildQuestionSection: function buildQuestionSection(_ref2, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var getters, rootGetters, commit, dispatch, section, questions, surveyQuestions, screens, _iterator, _step, surveyQuestion, screen;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getters = _ref2.getters, rootGetters = _ref2.rootGetters, commit = _ref2.commit, dispatch = _ref2.dispatch;
              section = payload.section; // Ensure we're working with a copy so we're not affecting store state.

              questions = getSortedQuestions(cloneDeep(rootGetters['surveys/surveyQuestions'](getters.getSurvey.templateId))); // Perform the question selection algorithm

              _context2.next = 5;
              return QuestionTypes.selectQuestions({
                section: section,
                survey: getters.getSurvey,
                questions: questions
              });

            case 5:
              surveyQuestions = _context2.sent;
              // Map selected questions to screens to be rendered, removing any that decided not to be rendered.
              screens = [];
              _iterator = _createForOfIteratorHelper(surveyQuestions);
              _context2.prev = 8;

              _iterator.s();

            case 10:
              if ((_step = _iterator.n()).done) {
                _context2.next = 18;
                break;
              }

              surveyQuestion = _step.value;
              _context2.next = 14;
              return dispatch('renderSurveyQuestion', {
                surveyQuestion: surveyQuestion
              });

            case 14:
              screen = _context2.sent;

              if (screen) {
                screens.push(screen);
              }

            case 16:
              _context2.next = 10;
              break;

            case 18:
              _context2.next = 23;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](8);

              _iterator.e(_context2.t0);

            case 23:
              _context2.prev = 23;

              _iterator.f();

              return _context2.finish(23);

            case 26:
              commit('setSectionScreens', {
                section: section,
                screens: screens
              });

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 20, 23, 26]]);
    }))();
  },

  /**
   * Builds screens for any non-question section
   *
   * @param {Object} getters Vuex module getters
   * @param {Function} commit Vuex module commit
   *
   * @param {Object} payload
   */
  buildNonQuestionSection: function buildNonQuestionSection(_ref3, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var getters, commit, section, context, screens, screen;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getters = _ref3.getters, commit = _ref3.commit;
              section = payload.section;
              context = {
                section: section,
                survey: getters.getSurvey
              }; // Perform question selection and rendering (if selected)

              screens = [];
              _context3.next = 6;
              return QuestionTypes.select(context);

            case 6:
              if (!_context3.sent) {
                _context3.next = 11;
                break;
              }

              _context3.next = 9;
              return QuestionTypes.render(context);

            case 9:
              screen = _context3.sent;

              if (screen) {
                screens.push(screen);
              }

            case 11:
              commit('setSectionScreens', {
                section: section,
                screens: screens
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * Builds a generic section - when sections & questions are merged on the backend, this will
   * eliminate the use for the sub-functions called here.
   *
   * @param {Function} dispatch Vuex module dispatch
   *
   * @param {Object} payload
   */
  buildSection: function buildSection(_ref4, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var dispatch, section;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch = _ref4.dispatch;
              section = payload.section;
              Logger.debug("Building section: ".concat(section.name, ".."));

              if (!(section.name === 'questions')) {
                _context4.next = 8;
                break;
              }

              _context4.next = 6;
              return dispatch('buildQuestionSection', payload);

            case 6:
              _context4.next = 10;
              break;

            case 8:
              _context4.next = 10;
              return dispatch('buildNonQuestionSection', payload);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * Builds any sections dependent on any dependent sections the first time they're ready to be built.
   *
   * @param {Object} getters Vuex module getters
   * @param {Function} dispatch Vuex module dispatch
   */
  buildDependentSections: function buildDependentSections(_ref5) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var getters, dispatch, sectionName, section;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              getters = _ref5.getters, dispatch = _ref5.dispatch;
              _context5.t0 = _regeneratorRuntime.keys(QuestionTypes.dependencyMap());

            case 2:
              if ((_context5.t1 = _context5.t0()).done) {
                _context5.next = 11;
                break;
              }

              sectionName = _context5.t1.value;
              // Check if the dependent section is ready to be rendered
              section = getters.getReadyDependentSection(sectionName); // Either the section is unready or already computed - so we're done.

              if (section) {
                _context5.next = 7;
                break;
              }

              return _context5.abrupt("continue", 2);

            case 7:
              _context5.next = 9;
              return dispatch('buildSection', {
                section: section
              });

            case 9:
              _context5.next = 2;
              break;

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * Trigger any follow-up questions associated with a survey question.
   */
  triggerFollowUpQuestions: function triggerFollowUpQuestions(_ref6, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _state$sections;

      var state, getters, rootGetters, dispatch, commit, questionId, triggeredFollowUpQuestions, currentScreens, currentQuestions, currentQuestionIndex, scheduledQuestions, section, newScreenQuestions, newScreens, _iterator2, _step2, _loop;

      return _regeneratorRuntime.wrap(function _callee6$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = _ref6.state, getters = _ref6.getters, rootGetters = _ref6.rootGetters, dispatch = _ref6.dispatch, commit = _ref6.commit;
              // Only trigger follow up questions when a survey question has been answered, not e.g. for
              // general comments or the NPS slider which won't have them. That's indicated by this questionId
              // being set.
              questionId = payload.questionId;

              if (questionId) {
                _context7.next = 4;
                break;
              }

              return _context7.abrupt("return");

            case 4:
              triggeredFollowUpQuestions = getTriggeredFollowUpQuestions(getters.getQuestionsDetail, questionId, rootGetters['answers/getAnswerBySurveyQuestionId'](questionId)); // Don't do any extra work if after all this there are no potential follow-ups to insert into the survey.

              if (triggeredFollowUpQuestions.length) {
                _context7.next = 7;
                break;
              }

              return _context7.abrupt("return");

            case 7:
              Logger.debug('Triggered follow-ups for', questionId, triggeredFollowUpQuestions); // Get the currently scheduled screens for the questions section and find where we are in it.
              // Note that no question will *ever* be inserted before the current question (this is relevant
              // for deferred = linked questions)

              currentScreens = cloneDeep(_toConsumableArray(((_state$sections = state.sections) === null || _state$sections === void 0 ? void 0 : _state$sections.questions) || []));
              currentQuestions = currentScreens.map(function (s) {
                return s.question;
              });
              currentQuestionIndex = currentQuestions.findIndex(function (q) {
                return q.id === questionId;
              });

              if (!(currentQuestionIndex < 0)) {
                _context7.next = 13;
                break;
              }

              return _context7.abrupt("return");

            case 13:
              scheduledQuestions = insertFollowUpQuestions(currentQuestions, currentQuestionIndex, triggeredFollowUpQuestions);
              Logger.debug('Scheduled questions after inserting follow-up questions', scheduledQuestions); // Now that we've updated the set of questions with the positioned follow-ups (which come after
              // `currentQuestionIndex`), apply question selection which will filter out questions that don't
              // meet their criteria, and this will also filter out questions that exceed question maximums.

              section = getters.getSection('questions');
              _context7.next = 18;
              return QuestionTypes.selectQuestions({
                section: section,
                survey: getters.getSurvey,
                questions: scheduledQuestions.slice(currentQuestionIndex + 1),
                existingQuestions: currentQuestions.slice(0, currentQuestionIndex + 1),
                knownPassingQuestionIds: currentQuestions.map(function (q) {
                  return q.id;
                })
              });

            case 18:
              newScreenQuestions = _context7.sent;
              Logger.debug('Scheduled questions after filtering', newScreenQuestions); // Rebuild questions screens from the questions scheduled to be posed.

              newScreens = [];
              _iterator2 = _createForOfIteratorHelper(newScreenQuestions);
              _context7.prev = 22;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var surveyQuestion, renderedScreen;
                return _regeneratorRuntime.wrap(function _loop$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        surveyQuestion = _step2.value;
                        // Most of the time, the screen will have already been built for the question - so we should
                        // re-use that. Which saves potential API calls used in building the screen.
                        renderedScreen = currentScreens.find(function (s) {
                          return s.questionId === surveyQuestion.id;
                        }); // Else, if hadn't already rendered the screen, then we need to render it.

                        if (renderedScreen) {
                          _context6.next = 6;
                          break;
                        }

                        _context6.next = 5;
                        return dispatch('renderSurveyQuestion', {
                          surveyQuestion: surveyQuestion
                        });

                      case 5:
                        renderedScreen = _context6.sent;

                      case 6:
                        if (renderedScreen) {
                          newScreens.push(renderedScreen);
                        }

                      case 7:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _loop);
              });

              _iterator2.s();

            case 25:
              if ((_step2 = _iterator2.n()).done) {
                _context7.next = 29;
                break;
              }

              return _context7.delegateYield(_loop(), "t0", 27);

            case 27:
              _context7.next = 25;
              break;

            case 29:
              _context7.next = 34;
              break;

            case 31:
              _context7.prev = 31;
              _context7.t1 = _context7["catch"](22);

              _iterator2.e(_context7.t1);

            case 34:
              _context7.prev = 34;

              _iterator2.f();

              return _context7.finish(34);

            case 37:
              commit('setSectionScreens', {
                section: section,
                screens: newScreens
              });

            case 38:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee6, null, [[22, 31, 34, 37]]);
    }))();
  },

  /**
   * Initialise screens for all sections
   *
   * @param {Object} getters Vuex module getters
   * @param {Function} dispatch Vuex module dispatch
   */
  initialiseScreens: function initialiseScreens(_ref7) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var getters, dispatch, _iterator3, _step3, section;

      return _regeneratorRuntime.wrap(function _callee7$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              getters = _ref7.getters, dispatch = _ref7.dispatch;
              _context8.next = 3;
              return dispatch('buildDependentSections');

            case 3:
              Logger.debug('Building screens');

              if (getters.getSurvey) {
                _context8.next = 6;
                break;
              }

              return _context8.abrupt("return");

            case 6:
              // Translate sections into screens
              _iterator3 = _createForOfIteratorHelper(getters.getSections);
              _context8.prev = 7;

              _iterator3.s();

            case 9:
              if ((_step3 = _iterator3.n()).done) {
                _context8.next = 17;
                break;
              }

              section = _step3.value;

              if (!(section.name in QuestionTypes.dependencyMap())) {
                _context8.next = 13;
                break;
              }

              return _context8.abrupt("continue", 15);

            case 13:
              _context8.next = 15;
              return dispatch('buildSection', {
                section: section
              });

            case 15:
              _context8.next = 9;
              break;

            case 17:
              _context8.next = 22;
              break;

            case 19:
              _context8.prev = 19;
              _context8.t0 = _context8["catch"](7);

              _iterator3.e(_context8.t0);

            case 22:
              _context8.prev = 22;

              _iterator3.f();

              return _context8.finish(22);

            case 25:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee7, null, [[7, 19, 22, 25]]);
    }))();
  },

  /**
   * Track completed screens
   *
   * @param {Function} dispatch Vuex module dispatch
   */
  addCompletedScreen: function addCompletedScreen(_ref8, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var commit, dispatch;
      return _regeneratorRuntime.wrap(function _callee8$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref8.commit, dispatch = _ref8.dispatch;

              // only add screen to completed sections if the screen hasnt already been completed
              if (!payload.alreadyComplete) {
                commit('addCompletedScreen', payload.screen);
              } // Ensure we attempt to apply dependent question selection every time a screen is completed.


              _context9.next = 4;
              return dispatch('buildDependentSections');

            case 4:
              _context9.next = 6;
              return dispatch('triggerFollowUpQuestions', payload.screen);

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee8);
    }))();
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  // Make default getters
  completedScreens: function completedScreens(state) {
    return state.completedScreens;
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //    ____
  //   / __/__________ ___ ___  ___
  //  _\ \/ __/ __/ -_) -_) _ \(_-<
  // /___/\__/_/  \__/\__/_//_/___/
  //

  /**
   * Calculates if the time has come to compute the screens to show in a section depends on Indicator Rules being answered.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @returns {Boolean} True if question screens should be computed, else false.
   */
  dependentSectionReady: function dependentSectionReady(state, getters) {
    return function (sectionName) {
      // Determine which sections the guest has already 'completed'. This method isn't 100% accurate (e.g. when it comes to questions),
      // but we don't need it for that right now, and when everything becomes a question, the whole concept of a section'll be thrown away anyhow.
      var completedSections = state.completedScreens.map(function (screen) {
        return screen.section.name;
      }); // Determine where the section is placed.

      var sections = getters.getSections;
      var sectionIndex = sections.findIndex(function (section) {
        return section.name == sectionName;
      }); // If there is no section of name specified, then we're done.

      if (sectionIndex < 0) {
        return false;
      } // We're ready to build the section if all dependent sections (indicators, nps) weighted before the section have been completed.


      var dependencies = QuestionTypes.dependencyMap()[sectionName] || [];
      var incompleteDependencies = sections.slice(0, sectionIndex).filter(function (section) {
        return dependencies.includes(section.name);
      }).filter(function (section) {
        return !completedSections.includes(section.name);
      });
      return !incompleteDependencies.length;
    };
  },

  /**
   * Gets a dependent section which is ready to be populated with screens, and hasn't already been populated
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @param {String} sectionName Section name
   *
   * @returns {Object} Section
   */
  getReadyDependentSection: function getReadyDependentSection(state, getters) {
    return function (sectionName) {
      // If Question screens aren't available yet, don't return any.
      if (!getters.dependentSectionReady(sectionName)) {
        return null;
      } // If we've already pre-computed the question screens, just return them. We've used null for the sentinel so we don't repeatedly compute if the result was an empty set.


      if (Array.isArray(state.sections[sectionName])) {
        return null;
      } // Find the question section - if there is none - we're done.


      return getters.getSections.find(function (s) {
        return s.name === sectionName;
      });
    };
  },

  /**
   * Main entry point for calculation of which screens to show and returns a sorted array of available screens.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @returns {Array} Array of screens
   */
  getScreens: function getScreens(state, getters) {
    return getters.getSections.reduce(function (screens, section) {
      return [].concat(_toConsumableArray(screens), _toConsumableArray(state.sections[section.name] || []));
    }, []);
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //   __  ____  _ ___ __
  //  / / / / /_(_) (_) /___ __
  // / /_/ / __/ / / / __/ // /
  // \____/\__/_/_/_/\__/\_, /
  //                    /___/

  /**
   * Gets the sections for the currently loaded survey.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex root state
   * @param {Object} rootGetters Vuex root getters
   *
   * @returns {Array} Array of sections
   */
  getSections: function getSections(state, getters) {
    // get survey in progress - if missing, return empty array
    var survey = getters.getSurvey;

    if (!survey) {
      return [];
    } // get 'sections' and return empty array if empty or null


    var sections = survey.sections;

    if (!Array.isArray(sections)) {
      return [];
    } // order sections by weight


    return sections.sort(function (a, b) {
      return b.weight - a.weight;
    });
  },

  /**
   * Finds a section by name
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex root state
   * @param {Object} rootGetters Vuex root getters
   *
   * @param {String} sectionName Section name
   *
   * @returns {Object} Section
   */
  getSection: function getSection(state, getters) {
    return function (sectionName) {
      return getters.getSections.find(function (section) {
        return section.name == sectionName;
      });
    };
  },

  /**
   * Gets the current survey model.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex root state
   * @param {Object} rootGetters Vuex root getters
   *
   * @returns {Object} Survey
   */
  getSurvey: function getSurvey(state, getters, rootState, rootGetters) {
    // get surveyInProgress index - bail if missing or NaN
    var surveyInProgress = rootState.surveys.surveyInProgress;

    if (typeof surveyInProgress !== 'number') {
      return null;
    } // return survey object matching surveyInProgress index


    return cloneDeep(rootGetters['surveys/survey'](surveyInProgress));
  },

  /**
   * Gets the current survey questions detail.
   */
  getQuestionsDetail: function getQuestionsDetail(state, getters, rootState, rootGetters) {
    var surveyInProgress = rootState.surveys.surveyInProgress;

    if (typeof surveyInProgress !== 'number') {
      return null;
    }

    return cloneDeep(rootGetters['surveys/questionsDetail'](surveyInProgress));
  },

  /**
   * Gets the datetime for the visit.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex root state
   * @param {Object} rootGetters Vuex root getters
   *
   * @returns {Object} Moment-ified visit datetime
   */
  getVisitDatetime: function getVisitDatetime(state, getters, rootState, rootGetters) {
    var visitDatetime = rootGetters['checkIn/visitDetails'].datetime;

    if (!visitDatetime) {
      return null;
    }

    return moment(visitDatetime);
  },

  /**
   *
   * @param {Object} state
   * @returns the count of the total number of questions available to be answered by the user
   */
  getQuestionsCount: function getQuestionsCount(state) {
    var sectionNames = Object.keys(state.sections);
    var questions = [];

    for (var _i = 0, _sectionNames = sectionNames; _i < _sectionNames.length; _i++) {
      var name = _sectionNames[_i];

      var _iterator4 = _createForOfIteratorHelper(state.sections[name]),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var section = _step4.value;
          questions.push.apply(questions, _toConsumableArray((section === null || section === void 0 ? void 0 : section.questions) || []));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    return questions.length;
  }
});

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   * Add a completed screen to be tracked
   *
   * @param {Object} state Vuex module state
   * @params {Object} payload Screen payload
   *
   * @returns {Void}
   */
  addCompletedScreen: function addCompletedScreen(state, payload) {
    state.completedScreens.push(payload);
  },

  /**
   * Sets screens for a given section
   *
   * @param {Object} state Vuex module state
   * @params {Object} payload Screen payload
   *
   * @returns {Void}
   */
  setSectionScreens: function setSectionScreens(state, payload) {
    Vue.set(state.sections, payload.section.name, payload.screens);
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};